import { render } from "./PrescriberNIMSelect.vue?vue&type=template&id=ed5863c0"
import script from "./PrescriberNIMSelect.vue?vue&type=script&lang=js"
export * from "./PrescriberNIMSelect.vue?vue&type=script&lang=js"

import "./PrescriberNIMSelect.vue?vue&type=style&index=0&id=ed5863c0&lang=scss"

import exportComponent from "/home/runner/work/rust-webserver/rust-webserver/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__